module.exports = __webpack_public_path__ + "img/RunwayAngel.e5278e3a.jpg";